/**
 * @license Copyright (c) 2014-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';

import { Alignment } from '@ckeditor/ckeditor5-alignment';
import { Bold, Code, Italic, Underline } from '@ckeditor/ckeditor5-basic-styles';
import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { FindAndReplace } from '@ckeditor/ckeditor5-find-and-replace';
import { FontSize } from '@ckeditor/ckeditor5-font';
import { Heading } from '@ckeditor/ckeditor5-heading';
import { Indent } from '@ckeditor/ckeditor5-indent';
import { AutoLink, Link } from '@ckeditor/ckeditor5-link';
import { List } from '@ckeditor/ckeditor5-list';
import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
import { RemoveFormat } from '@ckeditor/ckeditor5-remove-format';
import { SelectAll } from '@ckeditor/ckeditor5-select-all';
import { HeadingElementOption, HeadingParagraphOption } from '@ckeditor/ckeditor5-heading/src/headingconfig';

// You can read more about extending the build with additional plugins in the "Installing plugins" guide.
// See https://ckeditor.com/docs/ckeditor5/latest/installation/plugins/installing-plugins.html for details.

class Editor extends ClassicEditor {
	public static override builtinPlugins = [
		Alignment,
		AutoLink,
		BlockQuote,
		Bold,
		Code,
		Essentials,
		FindAndReplace,
		FontSize,
		Heading,
		Indent,
		Italic,
		Link,
		List,
		Paragraph,
		RemoveFormat,
		SelectAll,
		Underline
	];

	public static override defaultConfig  = {
		toolbar: {
			items: [
				'undo',
				'redo',
				'|',
				'heading',
				'fontSize',
				'|',
				'bold',
				'italic',
				'underline',
				'code',
				'blockQuote',
				'link',
				'|',
				'bulletedList',
				'numberedList',
				'alignment',
				'indent',
				'outdent',
				'|',
				'findAndReplace',
				'selectAll',
				'removeFormat'
			]
		},
		heading: {
			options: [
				{ model: 'paragraph', title: 'Parrafo', class: 'ck-heading_paragraph' } as HeadingParagraphOption,
				{
					model: 'heading1',
					view: {
							name: 'h1',
							styles: {
								'font-size': '2em',
								'font-weight': 'bold',
							}
					},
					title: 'Heading 1',
					class: 'ck-heading_heading1'
				} as HeadingElementOption,
				{
					model: 'heading2',
					view: {
							name: 'h2',
							styles: {
									'font-size': '1.75em',
									'font-weight': 'bold',
							}
					},
					title: 'Heading 2',
					class: 'ck-heading_heading2'
				} as HeadingElementOption,
				{
					model: 'heading3',
					view: {
							name: 'h3',
							styles: {
									'font-size': '1.5em',
									'font-weight': 'bold',
							}
					},
					title: 'Heading 3',
					class: 'ck-heading_heading3'
				} as HeadingElementOption,
				{
					model: 'heading4',
					view: {
							name: 'h4',
							styles: {
									'font-size': '1.25em',
									'font-weight': 'bold',
							}
					},
					title: 'Heading 4',
					class: 'ck-heading_heading4'
				} as HeadingElementOption
			]
		},
		language: 'es'
	};
}

export default Editor;
